import { axios, base } from '../http';

/**
 * 心理模块专用校区列表（勿从巨大的 misc.js 按名导入，避免生产包命名导出绑错）。
 * 创建于 2026-10-17
 */
export const getCampusList = (params) => {
  return axios.get(`${base}/api/Campus/GetList`, { params });
};

// ==================== 1. 心理老师管理 ====================

export const getPsychologyTeacherListPage = (params) => {
  return axios.get(`${base}/api/PsychologyTeacher/GetList`, { params });
};

export const getPsychologyCandidateTeachers = (params) => {
  return axios.get(`${base}/api/PsychologyTeacher/GetCandidateTeachers`, { params });
};

export const addPsychologyTeacher = (data) => {
  return axios.post(`${base}/api/PsychologyTeacher/Add`, data);
};

export const updatePsychologyTeacher = (data) => {
  return axios.post(`${base}/api/PsychologyTeacher/Update`, data);
};

export const togglePsychologyTeacherEnable = (params) => {
  return axios.post(`${base}/api/PsychologyTeacher/ToggleEnable`, null, { params });
};

export const deletePsychologyTeacher = (params) => {
  return axios.post(`${base}/api/PsychologyTeacher/Delete`, null, { params });
};

// ==================== 2. 校区心理配置 ====================

export const getPsychologyCampusConfig = (params) => {
  return axios.get(`${base}/api/PsychologyConfig/GetCampusConfig`, { params });
};

export const savePsychologyCampusConfig = (data) => {
  return axios.post(`${base}/api/PsychologyConfig/SaveCampusConfig`, data);
};

export const getPsychologySpecialCourseTimes = (params) => {
  return axios.get(`${base}/api/PsychologyConfig/GetSpecialCourseTimes`, { params });
};

export const copyCampusPsychologyConfig = (data) => {
  return axios.post(`${base}/api/PsychologyConfig/CopyCampusPsychologyConfig`, data);
};

// ==================== 3. 表单字段与选项字典 ====================

export const getPsychologyFormFields = (params) => {
  return axios.get(`${base}/api/PsychologyForm/GetFormFields`, { params });
};

export const updatePsychologyFormField = (data) => {
  return axios.post(`${base}/api/PsychologyForm/UpdateFormField`, data);
};

export const batchUpdatePsychologyFormFields = (list) => {
  return axios.post(`${base}/api/PsychologyForm/BatchUpdateFormFields`, list);
};

export const resetDefaultPsychologyFormFields = (params) => {
  return axios.post(`${base}/api/PsychologyForm/ResetDefaultFields`, null, { params });
};

export const getPsychologyDictItems = (params) => {
  return axios.get(`${base}/api/PsychologyForm/GetDictItems`, { params });
};

export const savePsychologyDictItem = (data) => {
  return axios.post(`${base}/api/PsychologyForm/SaveDictItem`, data);
};

export const deletePsychologyDictItem = (params) => {
  return axios.post(`${base}/api/PsychologyForm/DeleteDictItem`, null, { params });
};

// ==================== 4. 学生档案、三表与预约 ====================

export const getPsychologyArchiveList = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/GetArchiveList`, { params });
};

export const getPsychologyArchiveDetail = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/GetArchiveDetail`, { params });
};

export const updatePsychologyArchive = (data) => {
  return axios.post(`${base}/api/PsychologyArchive/UpdateArchive`, data);
};

export const getPsychologyArchiveForm = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/GetArchiveForm`, { params });
};

export const getPsychologyArchiveChangeLogs = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/GetArchiveChangeLogs`, { params });
};

export const downloadPsychologyArchivePaper = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/DownloadArchivePaper`, { params, responseType: 'blob' });
};

/** 按范围导出纸表 ZIP（人多时耗时长，单独放宽超时）。最后更新：2026-11-02 */
export const exportPsychologyClassArchiveZip = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/ExportClassArchiveZip`, {
    params,
    responseType: 'blob',
    timeout: 900000
  });
};

export const savePsychologyCounselingRecord = (data) => {
  return axios.post(`${base}/api/PsychologyArchive/SaveCounselingRecord`, data);
};

export const deletePsychologyCounselingRecord = (params) => {
  return axios.post(`${base}/api/PsychologyArchive/DeleteCounselingRecord`, null, { params });
};

export const getStudentCounselingRecords = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/GetStudentCounselingRecords`, { params });
};

export const getStudentAppointments = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/GetStudentAppointments`, { params });
};

export const getPsychologyAppointments = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/GetAppointments`, { params });
};

export const getPsychologySummaryReport = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/GetSummaryReport`, { params });
};

/** 导出台账 Excel（可含三角色明细，人多时略放宽超时）。最后更新：2026-11-02 */
export const exportPsychologyArchives = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/ExportArchives`, {
    params,
    responseType: 'blob',
    timeout: 600000
  });
};

export const exportPsychologyAppointments = (params) => {
  return axios.get(`${base}/api/PsychologyArchive/ExportAppointments`, { params, responseType: 'blob' });
};
